// src/language/zh.js
// 定义中文语言包对象
export default {
  登录: "登录",
  个人中心: "个人中心",
  学习进度: "学习进度",
  邮箱: "邮箱",
  联系方式: "联系方式",
  站内信: "站内信",
  官方客服: "官方客服",
  调查问卷: "调查问卷",
  客诉通道: "客诉通道",
  能力诊断: "能力诊断",
  试卷题目: "试卷题目",
  多选题: "多选题",
  单选题: "单选题",
  判断题: "判断题",
  提示: "提示",
  请您确认是否提交试卷: "请您确认是否提交试卷",
  继续答题: "继续答题",
  提交: "提交",
  提交试卷: "提交试卷",
  分: "分",
  "分(秒)": "分",
  重新答题: "重新答题",
  答题记录: "答题记录",
  推荐课程: "推荐课程",
  成绩: "成绩",
  考试时长: "考试时长",
  开始时间: "开始时间",
  提交时间: "提交时间",
  操作: "操作",
  查看明细: "查看明细",
  查看试卷: "查看试卷",
  首页: "首页",
  人才认证: "人才认证",
  我的成就: "我的成就",
  更多认证: "更多认证",
  报名: "报名",
  证书查询: "证书查询",
  姓名: "姓名",
  证书编号: "证书编号",
  查询: "查询",
  学员名称: "学员名称",
  手机号码: "手机号码",
  身份证号码: "身份证号码",
  编号: "编号",
  证书名称: "证书名称",
  有效期: "有效期",
  下载证书: "下载证书",
  完课考试: "完课考试",
  学习记录: "学习记录",
  学习时长: "学习时长",
  门: "门",
  个: "个",
  课程名称: "课程名称",
  完课率: "完课率",
  完课成绩: "完课成绩",
  完课时间: "完课时间",
  "抱歉，该内容已下架": "抱歉，该内容已下架",
  返回首页: "返回首页",
  敬请期待: "敬请期待",
  课程学习: "课程学习",
  认证考试: "认证考试",
  课程中心: "课程中心",
  全部: "全部",
  请输入关键字: "请输入关键字",
  开始学习: "开始学习",
  课程简介: "课程简介",
  自动连播: "自动连播",
  课程目录: "课程目录",
  本讲简介: "本讲简介",
  小结巩固: "小结巩固",
  随堂小测: "随堂小测",
  开始测试: "开始测试",
  问题反馈: "问题反馈",
  学员评论: "学员评论",
  "请提出您对本章节的建议，帮助我们后续改进":
    "请提出您对本章节的建议，帮助我们后续改进",
  管理员: "管理员",
  已加载全部: "已加载全部",
  没有更多了: "没有更多了",
  全部已读: "全部已读",
  删除: "删除",
  分钟前: "分钟前",
  小时前: "小时前",
  天前: "天前",
  当日课程: "当日课程",
  立即预约: "立即预约",
  立即查看: "立即查看",
  您的得分为: "您的得分为",
  "恭喜您通过此次考试！": "恭喜您通过此次考试！",
  重新考试: "重新考试",
  继续学习: "继续学习",
  考试次数已用尽: "考试次数已用尽",
  考试成绩: "考试成绩",
  "很遗憾,您未通过此次考试, 考试机会已用完！":
    "很遗憾,您未通过此次考试, 考试机会已用完！",
  "很遗憾,您未通过此次考试, 还剩N次考试机会！":
    "很遗憾,您未通过此次考试, 还剩{text}次考试机会！",
  恭喜您获得了N认证证书: "恭喜您获得了{text}认证证书",
  "可前往『 我的成就-我的认证』中查看": "可前往『 我的成就-我的认证』中查看",
  官方推荐: "官方推荐", 
  官方: "官方",
  推荐: "推荐",
  查看更多: "查看更多",
  暂无数据: "暂无数据",
  上月: "上月",
  下月: "下月",
  今天: "今天",
  我的认证: "我的认证",
  必看好课: "必看好课",
  必看: "必看",
  好课: "好课",
  精品课程: "精品课程",
  "扫描群二维码,立刻加入该群": "扫描群二维码,立刻加入该群",
  出海学堂满意度调查: "出海学堂满意度调查",
  "从总体而言,您对该网课平台的整体满意度如何？":
    "从总体而言,您对该网课平台的整体满意度如何？",
  "您认为该平台所提供的课程质量如何？": "您认为该平台所提供的课程质量如何？",
  "体验下来，课程视频的流畅程度是：": "体验下来，课程视频的流畅程度是：",
  "您认为课程内容对您的帮助程度是：": "您认为课程内容对您的帮助程度是：",
  "您是否会向其他人推荐该平台？": "您是否会向其他人推荐该平台？",
  "您对该平台有任何建议或意见吗？请详细叙述您的问题便于我们改进":
    "您对该平台有任何建议或意见吗？请详细叙述您的问题便于我们改进",
  请简述您的问题: "请简述您的问题",
  联系我们: "联系我们",
  "关于TikTok for Business 出海学堂还有疑问？":
    "关于TikTok for Business 出海学堂还有疑问？",
  我的收藏: "我的收藏",
  已学完: "已学完",
  已结束: "已结束",
  已看N: "已看{text}",
  已看完: "已看完",
  视频: "视频",
  学习资料: "学习资料",
  N人看过: "{text}人看过",
  PDF资料: "PDF资料",
  课程介绍: "课程介绍",
  适用人群: "适用人群",
  讲师团队: "讲师团队",
  友情链接: "友情链接",
  商务中心: "商务中心",
  广告管理平台: "广告管理平台",
  官网: "官网",
  条款和政策: "条款和政策",
  隐私条款: "隐私条款",
  "先人一步，现在就开始了解出海学堂": "先人一步，<span>现在就开始了解出海学堂</span>",
  认证流程: "认证流程",
  跨境营销认证流程: "跨境营销认证流程",
  报名认证: "报名认证",
  模拟练习: "模拟练习",
  认证考核: "认证考核",
  直播: "直播",
  认证: "认证",
  退出登录: "退出登录",
  帮助: "帮助",
  请输入姓名和证书编号: "请输入姓名和证书编号",
  消息: "消息",
  我的: "我的",
  游客登录: "游客登录",
  "游 客 登 录": "游 客 登 录",
  "TikTok for Business账号登录": "TikTok for Business账号登录",
  内部员工登录: "内部员工登录",
  "飞书群二维码，立刻加入该群": "飞书群二维码，立刻加入该群",
  取消: "取消",
  确认: "确认",
  星期一: "星期一",
  星期二: "星期二",
  星期三: "星期三",
  星期四: "星期四",
  星期五: "星期五",
  星期六: "星期六",
  星期日: "星期日",
  课程日历筛选: "课程日历筛选",
  课程日历: "课程日历",
  日历: "日历",
  "当前账号不支持此功能，请升级账号信息！":
    "当前账号不支持此功能，请升级账号信息！",
  知道了: "知道了",
  去升级: "去升级",
  收藏: "收藏",
  全部课程: "全部课程",
  请输入课程名称: "请输入课程名称",
  刚刚发布: "刚刚发布",
  正在学习: "正在学习",
  正在: "正在",
  学习: "学习",
  总分: "总分",
  答题时间: "答题时间",
  "网络异常，请重试！(错误码:) ": "网络异常，请重试！(错误码:) ",
  "认证信息数据异常，请刷新重试": "认证信息数据异常，请刷新重试",
  刷新页面: "刷新页面",
  "抱歉，您还没有该课程的查看权限": "抱歉，您还没有该课程的查看权限",
  跳转到课程中心: "跳转到课程中心",
  代理中心: "代理中心",
  当前主体: "当前主体",
  注册时间: "注册时间",
  已学课程数: "已学课程数",
  学习总时长: "学习总时长",
  暂无: "暂无",
  排行榜: "排行榜",
  当前排名: "当前排名",
  排名: "排名",
  名称: "名称",
  "查询出错，请检查查询条件": "查询出错，请检查查询条件",
  合作伙伴: "合作伙伴",
  官方证书: "官方证书",
  "跨境效果广告营销师（初级）": "跨境效果广告营销师（初级）",
  "跨境效果广告营销师（中级）": "跨境效果广告营销师（中级）",
  认证权益: "认证权益",
  出海学堂学习认证流程: "出海学堂学习认证流程",
  认证体系: "认证体系",
  "跨境创意素材营销师 初级、中级": "跨境创意素材营销师 初级、中级",
  "专注于跨境营销中的创意素材制作与趋势分析，提升营销的创意策划能力。":
    "专注于跨境营销中的创意素材制作与趋势分析，提升营销的创意策划能力。",
  "跨境小店投流营销师 初级、中级": "跨境小店投流营销师 初级、中级",
  "针对 TikTok 小店商家投流技能，培养营销人员在流量获取和转化方面的专业能力，帮助店铺实现曝光增长与业绩双增长":
    "针对 TikTok 小店商家投流技能，培养营销人员在流量获取和转化方面的专业能力，帮助店铺实现曝光增长与业绩双增长",
  回复: "回复",
  加载更多: "加载更多",
  提交成功: "提交成功",
  最新直播: "最新直播",
  直播中: "直播中",
  预告: "预告",
  回放: "回放",
  先人一步: "先人一步", 
  现在就开始了解出海学堂: "现在就开始了解出海学堂",
  请先登录: "请先登录",
  去登录: "去登录",
  登录方式: "登录方式",
  感谢您的反馈: "感谢您的反馈",
  N秒后自动关闭: "{text}秒后自动关闭",
  选择登录账户继续操作: "选择登录账户继续操作",
  "此课程为代理合作伙伴定制,非代理商身份无使用权限。如果您有疑问,请通过人工客服联系我们,我们将为您提供进一步的帮助。":
    "此课程为代理合作伙伴定制,非代理商身份无使用权限。如果您有疑问,请通过人工客服联系我们,我们将为您提供进一步的帮助。",
  代理商: "代理商",
  品牌方: "品牌方",
  代理商简称: "代理商简称",
  "请选择代理商，可通过关键字查询，如没有检索结果请选择其他选项":
    "请选择代理商，可通过关键字查询，如没有检索结果请选择其他选项",
  其他: "其他",
  请输入代理商简称: "请输入代理商简称",
  "请输入姓名（请填写你在公司的真实姓名）":
    "请输入姓名（请填写你在公司的真实姓名）",
  岗位: "岗位",
  请选择岗位信息: "请选择岗位信息",
  请输入具体岗位信息: "请输入具体岗位信息",
  公司邮箱: "公司邮箱",
  请输入公司邮箱: "请输入公司邮箱",
  "提示: 提交成功后,请耐心等待管理员审核.":
    "提示: 提交成功后,请耐心等待管理员审核.",
  "剩余审核次数:N次": "剩余审核次数:{text}次",
  主体名称: "主体名称",
  "请准确填写信息并选择正确主体，否则将无法正常进入学习": "请准确填写信息并选择正确主体，否则将无法正常进入学习",
  "请准确填写信息并选择正确主体，否则将无法正常进入学习SEA": "Please select the account name",

  "请准确填写您的开户主体信息。若信息偏差较大，我们将再次向您进行确认。":
    "请准确填写您的开户主体信息。若信息偏差较大，我们将再次向您进行确认。",
  待审核: "待审核",
  请填写岗位信息: "请填写岗位信息",
  请填写代理商简称: "请填写代理商简称",
  请输入正确的公司邮箱: "请输入正确的公司邮箱",
  请选择学员类型: "请选择学员类型",
  学员类型: "学员类型",
  请输入岗位信息: "请输入岗位信息",
  请输入姓名: "请输入姓名",
  "确认关闭？信息正确完善前，您的部分功能可能受限":
    "确认关闭？信息正确完善前，您的部分功能可能受限",
  确定关闭: "确定关闭",
  "您有新的消息！": "您有新的消息！",
  信息: "信息",
  确定: "确定",
  暂无课程: "暂无课程",
  认证科目简介: "认证科目简介",
  认证课程学习: "认证课程学习",
  预约考试: "预约考试",
  "认证/模拟考试": "认证/模拟考试",
  修改考试场次: "修改考试场次",
  "成绩待确认,请耐心等待!": "成绩待确认,请耐心等待!",
  查看证书: "查看证书",
  获取考试信息: "获取考试信息",
  课程反馈: "课程反馈",
  未开始: "未开始",
  以上内容对您是否有帮助: "以上内容对您是否有帮助",
  点击评分: "点击评分",
  试听: "试听",
  添加飞书群组: "添加飞书群组",
  请先在电脑端完成相关认证考试操作: "请先在电脑端完成相关认证考试操作",
  好的: "好的",
  请先观看完所有章节: "请先观看完所有章节",
  "内容下架了！": "内容下架了！",
  "此页面课程仅为代理商定制，非代理商身份不可用":
    "此页面课程仅为代理商定制，非代理商身份不可用",
  信息完善: "信息完善",
  选择: "选择",
  预约成功: "预约成功",
  "考试已结束！": "考试已结束！",
  请先答完所有问题: "请先答完所有问题",
  不要重复提交试卷: "不要重复提交试卷",
  能力自测: "能力自测",
  暂无推荐课: "暂无推荐课",
  正在拼命加载中: "正在拼命加载中",
  "该场直播暂未开放，敬请期待": "该场直播暂未开放，敬请期待",
  请用TTAM账号登录: "请用TTAM账号登录",
  更多问题: "更多问题",
  "以下是关于TikTok for Business 出海学堂 账户最常见的问题。":
    "以下是关于TikTok for Business 出海学堂 账户最常见的问题。",
  "如有其他问题，请随时与我们联系": "如有其他问题，请随时与我们联系",
  怎么称呼您: "怎么称呼您",
  请输入您的全名: "请输入您的全名",
  您的公司名称: "您的公司名称",
  请输入公司名称: "请输入公司名称",
  销售姓名: "销售姓名",
  请输入销售的姓名: "请输入销售的姓名",
  请输入您的邮箱: "请输入您的邮箱",
  "手机（选填）": "手机（选填）",
  请输入您的手机号码: "请输入您的手机号码",
  行业: "行业",
  请选择所属行业: "请选择所属行业",
  您的问题: "您的问题",
  请简述一下您的问题: "请简述一下您的问题",
  请输入正确格式: "请输入正确格式",
  请输入销售名称: "请输入销售名称",
  请描述一下您的问题: "请描述一下您的问题",
  清除未读: "清除未读",
  雷达图: "雷达图",
  个人雷达图: "个人雷达图",
  代理商雷达图: "代理商雷达图",
  昵称: "昵称",
  能力专项: "能力专项",
  学习课程: "学习课程",
  推荐学习计划: "推荐学习计划",
  得分: "得分",
  观看: "观看",
  正在加载: "正在加载",
  暂无内容: "暂无内容",
  选择筛选日历课程: "选择筛选日历课程",
  暂无相关课程: "暂无相关课程",
  前往观看: "前往观看",
  前往预约: "前往预约",
  直播详情: "直播详情",
  收到您的提交: "收到您的提交",
  "我们会在 48 小时内跟您联系！": "我们会在 48 小时内跟您联系！",
  完成: "完成",
  退出: "退出",
  能力雷达: "能力雷达",
  营销认证: "营销认证",
  讲师招募: "讲师招募",
  学霸实时排行榜: "学霸实时排行榜",
  人才认证超能排行榜: "人才认证超能排行榜",
  最新动态: "最新动态",
  查看详情: "查看详情",
  代理商学习计划: "代理商学习计划",
  好课推荐: "好课推荐",
  "平台鉴权中，成功后将自动跳转，请耐心等待":
    "平台鉴权中，成功后将自动跳转，请耐心等待",
  选择支付方式: "选择支付方式",
  个人支付: "个人支付",
  邀请码核销: "邀请码核销",
  请输入邀请码: "请输入邀请码",
  "若无法正常显示金额，刷新页面即可": "若无法正常显示金额，刷新页面即可",
  本轮支付优惠截止时间: "本轮支付优惠截止时间",
  我已悉知并同意以上认证报考须知: "我已悉知并同意以上认证报考须知",
  当前不在报名考试时间内: "当前不在报名考试时间内",
  在您验证邀请码前: "在您验证邀请码前",
  营销认证考试协议: "营销认证考试协议",
  勾选同意后进行下一步骤: "勾选同意后进行下一步骤",
  请点击链接详细阅读: "请点击链接详细阅读",
  证书详情: "证书详情",
  请先阅读并同意考试条款: "请先阅读并同意考试条款",
  请填写邀请码: "请填写邀请码",
  邀请码错误: "邀请码错误",
  支付校验错误: "支付校验错误",
  章节名称: "章节名称",
  时间: "时间",
  暂无证书: "暂无证书",
  登录成功: "登录成功",
  登录失败: "登录失败",
  授权验证中: "授权验证中 ",
  课程资源: "课程资源",
  点击进入代理商专属课程资源: "点击进入代理商专属课程资源",
  点击能力雷达图查看个人能力分析: "点击能力雷达图查看个人能力分析",
  学霸学时排行榜: "学霸学时排行榜",
  认证数量排行榜: "认证数量排行榜",
  月度新增数量排行榜: "月度新增数量排行榜",
  个人学习时长: "个人学习时长",
  查看: "查看",
  本月: "本月",
  必学: "必学",
  "完成此板块课程学习和考试，可在当月个人雷达图的计算中，获得对应能力项的学习积分":
    "完成此板块课程学习和考试，可在当月个人雷达图的计算中，获得对应能力项的学习积分",
  能力分析雷达图: "能力分析雷达图",
  "雷达图生成依据为学员在营销认证中的答题表现及日常学习表现，计算维度包含（认证成绩+日常学习得分）":
    "雷达图生成依据为学员在营销认证中的答题表现及日常学习表现，计算维度包含（认证成绩+日常学习得分）",
  个人通用能力雷达图: "个人通用能力雷达图",
  请选择证书行业: "请选择证书行业",
  个人: "个人",
  行业能力雷达图: "行业能力雷达图",
  所属公司能力雷达图: "所属公司能力雷达图",
  "推荐课程由个人能力雷达图表现为依据，依据用户需要提升的能力项，智能推荐课程。助力你成为多边形战士！":
    "推荐课程由个人能力雷达图表现为依据，依据用户需要提升的能力项，智能推荐课程。助力你成为多边形战士！",
  学习计划: "学习计划",
  最新: "最新",
  动态: "动态",
  课程: "课程",
  课程C: " 课程",
  中心: "中心",
  获得认证证书数: "获得认证证书数",
  在线时长: "在线时长",
  能力分析: "能力分析",

  权限提示: "权限提示",
  "学习时长：30天内累积学习时长": "学习时长：30天内累积学习时长",
  "排名箭头：体现用户30天内排名变化趋势":
    "排名箭头：体现用户30天内排名变化趋势",
  "认证证书排行：在官方代理营销认证考试中，累积通过人数在所有官方代理中的排名":
    "认证证书排行：在官方代理营销认证考试中，累积通过人数在所有官方代理中的排名",
  百分比: "百分比",
  精品: "精品",
  暂无试卷: "暂无试卷",
  关闭: "关闭",
  "若您有该课程学习码，请您准确填写！": "若您有该课程学习码，请您准确填写！",
  "若您没有，请您点击关闭按钮进入课程学习。":
    "若您没有，请您点击关闭按钮进入课程学习。",
  请输入您的学习码: "请输入您的学习码",
  学习码: "学习码",
  "开始学习前，请您先完成认证能力测评": "开始学习前，请您先完成认证能力测评",
  去认证考试: "去认证考试",
  信息完善SEA: "Information Completion",
  "此课程为代理合作伙伴定制,非代理商身份无使用权限。如果您有疑问,请通过人工客服联系我们,我们将为您提供进一步的帮助。SEA":
    "This course is tailored for agency partners and is only available for agencies. If you have any questions, please contact customer service for further assistance.",
  学员类型SEA: "Learner Type",
  代理商SEA: "CNOB Agency",
  品牌方SEA: "CNOB Client",
  代理商简称SEA: "Agency Name",
  "请选择代理商，可通过关键字查询，如没有检索结果请选择其他选项SEA":
    "Please select the agency name to match",
  其他SEA: "Other",
  请输入代理商简称SEA: "Please enter the agency name",
  "请输入姓名（请填写你在公司的真实姓名）SEA":
    "Please enter your name (use your real name at the company)",
  岗位SEA: "Position",
  请选择岗位信息SEA: "Please select your position",
  请输入具体岗位信息SEA: "Please enter your position",
  公司邮箱SEA: "Company Email",
  请输入公司邮箱SEA: "Please enter your Company Email",
  "提示: 提交成功后,请耐心等待管理员审核.SEA":
    "Note: Admin approval may take some time. Please be patient.",
  "剩余审核次数:N次SEA": "Remaining review attempts: {text}",
  姓名SEA: "Learner Name",
  "学员名称SEA":"Learner Name",
  提交SEA: "Submit",
  待审核SEA: "Pending review",
  请输入正确的公司邮箱SEA: "Please enter the correct Company Email",
  请输入岗位信息SEA: "Please enter your position",
  请输入姓名SEA: "Please enter your name",
  完课考试排行榜: "完课考试排行榜",

  素材服务商身份报名: "素材服务商身份报名",
  素材服务商名称: "素材服务商名称",
  请输入素材服务商名称: "请输入素材服务商名称",
  中国跨境代理商: "中国跨境代理商",
  中国跨境商家: "中国跨境商家",
  中国跨境代理商SEA: "China Outbound Agency",
  中国跨境商家SEA: "China Outbound Client",
  链接: "链接",
  学员答题详情: "学员答题详情",
  问题答案: "问题答案",
  "考试时长（分钟）": "分钟",
  试卷标题: "试卷标题",
  试卷时间: "试卷时间",
  学员UID: "学员UID",
  考试时间: "考试时间",
  答题时长: "答题时长",
  返回认证: "返回认证",
  认证能力测评: "认证能力测评",
  模拟练习题库: "模拟练习题库",
  总表: "总表",
  线下培训: "线下培训",
  系统提示: "系统提示",
  "当前检测到您的账号尚未绑定邮箱，这将导致无法完成考试认证。为确保您能顺利参加考试，请尽快点击下方链接完成邮箱绑定及信息完善：":
    "当前检测到您的账号尚未绑定邮箱，这将导致无法完成考试认证。为确保您能顺利参加考试，请尽快点击下方链接完成邮箱绑定及信息完善：",
  点击完善: "点击完善",
  已完成绑定: "已完成绑定",
  新客户成长计划:"新客户成长计划",
  "精心打造客户成长计划，整合优质资源，提供定制策略与专业指导，助力客户实现业绩持续跃升。":"精心打造客户成长计划，整合优质资源，提供定制策略与专业指导，助力客户实现业绩持续跃升。",


  //-----志成添加------
  电商出海新星成长计划:"电商出海新星<span>成长计划</span>",
  还需学习:"还需学习",
  您现在是否已掌握该门课程知识:"您现在是否已掌握该门课程知识",
  签到成功:"签到成功",
  直播签到:"直播签到",
  初级课程:"初级课程",
  中级课程:"中级课程",
  高级课程:"高级课程",
  操作成功:"操作成功",
  //------end----------
  "如您的PDF课程无法达成100%完成，请调整您的浏览器和文件框的缩放比例至100%。":
    "如您的PDF课程无法达成100%完成，请调整您的浏览器和文件框的缩放比例至100%。",

  //2026-01-14添加
  必修:"必修",  

  评分:"评分",
  浏览量:"浏览量",
  次观看:"次观看",
  广告主:"广告主",
  学习中心:"学习中心",
  为出海品牌打造的官方培训基地:"为出海品牌打造的官方培训基地",
  初级:"初级",
  进阶:"进阶",
  跨境认证介绍:"跨境认证介绍",
  考试报名须知:"考试报名须知",
  官方认证查询:"官方认证查询",
  "TikTok for Business 认证体系":"TikTok for Business 认证体系",
  认证上新:"认证上新",
  "TikTok for Business 认证权益":"TikTok for Business 认证权益",
  跨境营销认证权益:"跨境营销认证权益",
  理解:"理解", 
  入局:"入局",
  跨境营销:"入局跨境营销",
  知识体系:"知识体系",
  出海市场:"出海市场",
  "跨境营销信息流、创意素材、闭环投流等全面认知":"跨境营销信息流、创意素材、闭环投流等全面认知",
  "从营销趋势到实操技巧，全流程学习":"从营销趋势到实操技巧，全流程学习",
  "获得官方人才标准认证，提升出海方向就业竞争力":"获得官方人才标准认证，提升出海方向就业竞争力",
  高级:"高级",
  专业化学习:"专业化学习",
  专业化课程:"专业化课程",
  最热门证书:"最热门证书",
  "通过出海学堂学习，您可以培养宝贵的技能，获得职业证书。":"通过出海学堂学习，您可以培养宝贵的技能，获得职业证书。",
  "出海学堂专业化课程，包含值得信赖，符合标准的课程。覆盖电商，应用，美妆，通用，3C等。":"出海学堂专业化课程，包含值得信赖，符合标准的课程。覆盖电商，应用，美妆，通用，3C等。",
  "出海学堂为您提供，最受欢迎的课程，为热门职业做好就业准备。":"出海学堂为您提供，最受欢迎的课程，为热门职业做好就业准备。",
  "考试场次":"考试场次",
"了解更多认证":"了解更多认证",
"课程直达":"课程直达", 
"我还未成为 TikTok 广告主":"我还未成为 TikTok 广告主",
   "我是TikTok广告主/代理商":"我是TikTok广告主/代理商",
   "我是内部员工":"我是内部员工",

  "请您完善并准确填写所有信息，确保信息真实有效。信息填写无误后，方可正常进入平台学习并获得后续平台活动激励。您的所有信息将严格保密，不会对外泄露。感谢您的配合！":"请您完善并准确填写所有信息，确保信息真实有效。信息填写无误后，方可正常进入平台学习并获得后续平台活动激励。您的所有信息将严格保密，不会对外泄露。感谢您的配合！",
  "请您完善并准确填写所有信息，确保信息真实有效。信息填写无误后，方可正常进入平台学习并获得后续平台活动激励。您的所有信息将严格保密，不会对外泄露。感谢您的配合！SEA":"Please complete and accurately fill in all information to ensure its authenticity and validity.Only after the information is filled in correctly can you normally enter the platform to study and receive incentives for subsequent platform activities.All your information will be strictly confidential and will not be disclosed externally. Thank you for your cooperation!",
  请输入主体名称SEA: "Please enter the Account Name",
  "填写方式":"填写方式",
  "主体名称填写":"主体名称填写",
  "请选择主体名称":"请选择主体名称",
  "请输入":"请输入",
  "如您在填写过程中遇到问题,请扫码入群反馈":"如您在填写过程中遇到问题,请扫码入群反馈",
  "如您在填写过程中遇到问题,请扫码入群反馈SEA":"If you encounter any issues,please scan the QR code to join the group and ask for help",
  "请选择任一填写":"请选择任一填写",
  "查找方式":"查找方式",
  "请使用您的TTAM/BC账号及密码登录":"请使用您的TTAM/BC账号及密码登录",
  "如您还未成为TikTok for Business的广告主/代理商，请先完成":"如您还未成为TikTok for Business的广告主/代理商，请先完成",
  "注册":"注册",
  "忘记密码请返回":"忘记密码请返回",
  "平台进行找回":"平台进行找回",
  "您的TikTok for Business账号":" 您的TikTok for Business账号",
  "加入":"加入",
  "TikTok for Business打造的培训基地，在这里品牌和代理可以获取丰富的全行业课程和营销知识":"TikTok for Business打造的培训基地，在这里品牌和代理可以获取丰富的全行业课程和营销知识",
  "忘记密码":"忘记密码",
  "手机号":"手机号",
  "请输入手机号":"请输入手机号",
  "请输入邮箱":"请输入邮箱",
  "请输入密码":"请输入密码",
  "请输入验证码":"请输入验证码",
  "发送验证码":"发送验证码",
  "使用短信验证码登录":"使用验证码登录",
  "使用密码登录":"使用密码登录",
  "账号或密码错误，请重试":"账号或密码错误，请重试",
  "密码验证":"密码验证",
  "请注意：为了您的账号安全，请输入您的登录密码":"请注意：为了您的账号安全，请输入您的登录密码",
  "密码长度必须在6-20位之间":"密码长度必须在6-20位之间",
  "直播简介":"直播简介",
  "直播介绍": "直播介绍",
  "进入直播":"进入直播",
  "本直播链接仅支持当前设备访问转发他人将无法正常观看":"本直播链接仅支持当前设备访问转发他人将无法正常观看",
  "如无法访问可联系管理员或扫码入群反馈":"如无法访问可联系管理员或扫码入群反馈",
  "集团名称":"集团名称",
};
